module.exports = __webpack_public_path__ + "img/ins.661632a6.svg";